export default {
    HOME: '/',

    LOGIN: '/login',
    LOGOUT: '/logout',

    USER_LIST: '/user/list',
    USER_VIEW: '/user/view/:id',

    DAILY_INSPIRATION_LIST: '/daily-inspiration/list',
    DAILY_INSPIRATION_VIEW: '/daily-inspiration/view/:id',
    DAILY_INSPIRATION_CREATE: '/daily-inspiration/create',
    DAILY_INSPIRATION_EDIT: '/daily-inspiration/edit/:id',

    BIBLE_QUOTE_LIST: '/bible-quote/list',
    BIBLE_QUOTE_VIEW: '/bible-quote/view/:id',
    BIBLE_QUOTE_CREATE: '/bible-quote/create',
    BIBLE_QUOTE_EDIT: '/bible-quote/edit/:id',

    DATE_NIGHT_LIST: '/date-night/list',
    DATE_NIGHT_VIEW: '/date-night/view/:id',
    DATE_NIGHT_CREATE: '/date-night/create',
    DATE_NIGHT_EDIT: '/date-night/edit/:id',

    CONVERSATION_STARTER_LIST: '/conversation-starter/list',
    CONVERSATION_STARTER_VIEW: '/conversation-starter/view/:id',
    CONVERSATION_STARTER_CREATE: '/conversation-starter/create',
    CONVERSATION_STARTER_EDIT: '/conversation-starter/edit/:id',

    CONVERSATION_STARTER_CATEGORY_LIST: '/conversation-starter-category/list',
    CONVERSATION_STARTER_CATEGORY_VIEW: '/conversation-starter-category/view/:id',
    CONVERSATION_STARTER_CATEGORY_CREATE: '/conversation-starter-category/create',
    CONVERSATION_STARTER_CATEGORY_EDIT: '/conversation-starter-category/edit/:id',

    QUIZ_LIST: '/quizs/list',
    QUIZ_RESULTS_LIST: '/quiz/:id',
    QUIZ_ANSWER_EDIT: '/quiz-answer/edit/:id',

    ARTICLE_LIST: '/article/list',
    ARTICLE_VIEW: '/article/view/:id',
    ARTICLE_CREATE: '/article/create',
    ARTICLE_EDIT: '/article/edit/:id',

    ASSESSMENT_QUESTIONS_LIST: '/assessment-questions/list',
    ASSESSMENT_QUESTIONS_EDIT: '/assessment-questions/edit/:id',

    REWARD_LIST: '/reward/list',
    REWARD_CREATE: '/reward/create',
    REWARD_EDIT: '/reward/edit/:id',
    REWARD_REDEMPTION_LIST: '/reward/redemptions',

    DONATION_LIST: '/donation/list',

    APP_VERSION_LIST: '/app-version/list',
    APP_VERSION_CREATE: '/app-version/create',
    APP_VERSION_EDIT: '/app-version',
    USER_APP_VERSIONS: '/user-app-versions',
};
